import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Breadcrumb, Button, Modal } from "react-bootstrap";

const DsBreadcrumbs = ({ t, currentList, callbackBreadCrumb }) => {
  const handleClickBreadcrumb = (e, index, id) => {
    e.preventDefault();
    callbackBreadCrumb(index, id);
  };
  return (
    <Breadcrumb className="h6 m-0">
      {currentList?.map((item, index) =>
        index + 1 === currentList.length ? (
          <Breadcrumb.Item key={index} active>
            {item.name}
          </Breadcrumb.Item>
        ) : (
          <Breadcrumb.Item
            key={item.id}
            href="#"
            onClick={(e) => handleClickBreadcrumb(e, index, item.id)}
          >
            {item.name}
          </Breadcrumb.Item>
        )
      )}
    </Breadcrumb>
  );
};

export default withTranslation()(DsBreadcrumbs);
